import type { StorePassengersSchema } from "@/shared/schemas/hotel/storePassengersSchema";
import type { MinPriceRoom } from "@/types/services/hotel/apis/Detail";
import { createStore } from "zustand/vanilla";

export type HotelState = {
  filteredHotels: (Avail | CityAccommodationHotelAvail)[];
  isFiltered: boolean;
  isLoading: boolean;
  hasAvailListBeenLoaded: boolean;
  // - * - * - * - Hotel Detail - * - * - * //
  rooms: MinPriceRoom[];
  passengers: StorePassengersSchema | null;
};

export type HotelAction = {
  setFilteredHotels: (value: HotelState["filteredHotels"]) => void;
  setIsFiltered: (value: HotelState["isFiltered"]) => void;
  setHasAvailListBeenLoaded: (
    value: HotelState["hasAvailListBeenLoaded"],
  ) => void;
  setDetailRooms: (value: HotelState["rooms"]) => void;
  setPassengers: (value: HotelState["passengers"]) => void;
};

export type HotelStore = HotelState & HotelAction;

const defaultState: HotelState = {
  filteredHotels: [],
  isFiltered: false,
  isLoading: false,
  hasAvailListBeenLoaded: false,
  rooms: [],
  passengers: null,
};

export const createHotelStore = (initState: HotelState = defaultState) =>
  createStore<HotelStore>((set) => ({
    ...defaultState,
    setFilteredHotels: (filteredHotels) =>
      set(() => ({
        filteredHotels: filteredHotels,
      })),
    setIsFiltered: (isFiltered) => set(() => ({ isFiltered })),
    setHasAvailListBeenLoaded: (hasAvailListBeenLoaded) =>
      set(() => ({ hasAvailListBeenLoaded })),
    setDetailRooms: (rooms) =>
      set(() => ({
        rooms: rooms,
      })),
    setPassengers: (passengers) =>
      set(() => ({
        passengers: passengers,
      })),
  }));
